module.exports = __webpack_public_path__ + "img/test_photo.158b9673.svg";